module.exports = __webpack_public_path__ + "static/media/bola-02.7e9ba369.png";